const Home = () => {
    return (
      <div className="page-container">
        <h1>SAL PITA Ordering System</h1>
        <p>Place your orders effortlessly!</p>
      </div>
    );
  };
  
  export default Home;